/* unplugin-vue-components disabled */import { render } from "./follow-btn.vue?vue&type=template&id=e40bb18a&scoped=true"
import script from "./follow-btn.vue?vue&type=script&lang=js"
export * from "./follow-btn.vue?vue&type=script&lang=js"

import "./follow-btn.vue?vue&type=style&index=0&id=e40bb18a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e40bb18a"],['__file',"src/components/cards-v2/company/follow-btn.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e40bb18a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e40bb18a', __exports__)) {
    api.reload('e40bb18a', __exports__)
  }
  
  module.hot.accept("./follow-btn.vue?vue&type=template&id=e40bb18a&scoped=true", () => {
    api.rerender('e40bb18a', render)
  })

}


export default __exports__